<template>
  <section class="viewsrhqy_ReceiveSampleCollate p-4 space-y-2">
    <viewTitle title="业务管理 / 收样核对管理" :showReturn="true">
      <template slot="return">
        <el-button v-has="['c-cSample-record-export']" @click="onExport" type="primary" size="small">导出execl</el-button>
      </template>
    </viewTitle>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="收样任务号">
        <el-input
          clearable
          v-model="queryParam.task_no"
          placeholder="请输入收样任务号"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="加密号">
        <el-input
          clearable
          v-model="queryParam.package_no"
          placeholder="请输入加密号"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          class="w-60"
          clearable
          v-model="queryParam.state"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in stateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="送样时间">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="queryParam.sendTime"
          @change="refreshData"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="收样时间">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="timeRange"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small"
        >刷新数据
      </el-button>
      <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :isSelection="false"
      :selection.sync="rowKeySelection"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="send_time" slot-scope="{ row }">
        {{ row.send_time | timeFormat }}
      </template>
      <template slot="receive_time" slot-scope="{ row }">
        {{ row.receive_time | timeFormat }}
      </template>
      <template slot="business_list" slot-scope="{ row }">
        <div v-for="business in row.business_list">{{ business.name }}</div>
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link
            v-has="['c-cSample-record-detail']"
            @click="onViewDetail(row)"
            type="primary"
            label="查看明细"
          ></c-link>
          <c-link v-has="['c-cSample-record-delete']" @click="onDelete(row, 1)" label="删除" type="danger"></c-link>
        </div>
      </template>
    </c-table>
    <el-dialog title="查看明细" :close-on-click-modal="false" :visible.sync="detailVisible" width="1200px">
      <c-table
        :isIndex="false"
        class="mt-4"
        :query="{}"
        :data="detailData"
        :columns="detailColumns"
      >
        <template slot="send_scan_time" slot-scope="{ row }">
          {{ row.send_scan_time | timeFormat }}
        </template>
        <template slot="receive_scan_time" slot-scope="{ row }">
          {{ row.receive_scan_time | timeFormat }}
        </template>
      </c-table>
    </el-dialog>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  props: [""],

  data() {
    return {
      detailVisible: false,
      detailData: [],
      detailColumns: [
        { label: "样包加密号", prop: "package_no" },
        { label: "送样扫描时间", prop: "send_scan_time" },
        { label: "收样扫描时间", prop: "receive_scan_time" }
      ],
      columns: [
        { label: "收样任务号", prop: "task_no" },
        {
          label: "基地",
          prop: "com_name",
          formatData: () => this.baseInfo.com_name
        },
        { label: "样包数", prop: "package_count" },
        { label: "送样员", prop: "send_name" },
        { label: "送样时间", prop: "send_time" },
        { label: "送样点", prop: "sampling_point_name" },
        { label: "收样员", prop: "receive_name" },
        { label: "收样时间", prop: "receive_time" },
        {
          label: "状态",
          prop: "state",
          formatData: row => {
            return this.stateList.find(item => item.id === row.state).name;
          }
        },
        { label: "操作", prop: "action" }
      ],
      stateList: [
        { name: "未收样", id: 1 },
        { name: "已收样", id: 2 },
        { name: "已取消", id: 3 }
      ],
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除？删除后数据将不可恢复！",
        url: "/api/queue/dispatcher/delete_sampling_record"
      },
      exportDataEvent: params => {
        const { sendTime, begin_time, end_time, ...data } = params;
        return this.$common.http({
          url: "/api/queue/dispatcher/export_sampling_record",
          data: {
            ...data,
            send_begin_time: sendTime ? moment(sendTime[0]).unix() : "",
            send_end_time: sendTime ? moment(sendTime[1]).unix() : "",
            receive_begin_time: begin_time,
            receive_end_time: end_time
          },
          noLoading: true
        });
      },
      fetchDataEvent: params => {
        const { sendTime, begin_time, end_time, ...data } = params;
        return this.$common.http({
          url: "/api/queue/dispatcher/query_sampling_record",
          data: {
            ...data,
            send_begin_time: sendTime ? moment(sendTime[0]).unix() : "",
            send_end_time: sendTime ? moment(sendTime[1]).unix() : "",
            receive_begin_time: begin_time,
            receive_end_time: end_time
          }
        });
      }
    };
  },

  computed: {
    ...mapGetters(["baseInfo"])
  },

  watch: {},

  components: {},

  mixins: [initListMinxin, mixinTableLyout],

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    async onViewDetail(row) {
      try {
        const res = await this.$common.http({
          url: "/api/queue/dispatcher/detail_sampling_record",
          data: { id: row.id }
        });
        this.detailData = res.data.data.detail;
        this.$nextTick(() => {
          this.detailVisible = true;
        });
      } catch (error) {}
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 0px 15px 10px !important;
}
</style>
